import { render, staticRenderFns } from "./AddAttribute.vue?vue&type=template&id=2ade948f&scoped=true&"
import script from "./AddAttribute.vue?vue&type=script&lang=js&"
export * from "./AddAttribute.vue?vue&type=script&lang=js&"
import style0 from "./AddAttribute.vue?vue&type=style&index=0&id=2ade948f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ade948f",
  null
  
)

export default component.exports